module.exports = __webpack_public_path__ + "static/media/hero-tablet.58e9a1e9.jpg";